import { Environments } from '../types/environments.types';
import { getRegionShortName } from './getRegion';
import { US_REGION_SHORT_NAME } from './constants';
// Example: https://saas-favorites.wlc360i-c-uw2.autodesk.com
export const getUrlEnvLetterFromEnv = (env) => {
    switch (env) {
        case Environments.LOCAL:
            return 'c';
        case Environments.DEV:
            return 'c';
        case Environments.QA:
            return 's';
        case Environments.STAGE:
            return 's';
        case Environments.PROD:
            return 'p';
    }
};
/**
 * Maps string environment values to Environments enum
 */
const mapStringEnvToEnvironments = (env) => {
    switch (env.toLowerCase()) {
        case 'dev':
            return Environments.DEV;
        case 'qa':
            return Environments.QA;
        case 'stg':
        case 'stage':
            return Environments.STAGE;
        case 'prd':
        case 'prod':
            return Environments.PROD;
        default:
            return Environments.DEV;
    }
};
/**
 * Maps environment string to path segment
 * Maps "stage" to "stg" for the path
 * Maps "prod" to "prd" for the path
 */
const getEnvPath = (env) => {
    const normalizedEnv = env.toLowerCase();
    // Map stage to stg for path
    if (normalizedEnv === 'stage' ||
        normalizedEnv === 'stg' ||
        normalizedEnv === 'qa') {
        return 'stg';
    }
    // Map prod to prd for path
    if (normalizedEnv === 'prod' || normalizedEnv === 'prd') {
        return 'prd';
    }
    return normalizedEnv;
};
const appendPathToUrl = (url, env) => {
    return `${url}/${getEnvPath(env)}`;
};
const buildWlc360iOrigin = (subDomain, env) => {
    const lEnv = env.toLowerCase();
    if (!['dev', 'qa', 'stg', 'stage', 'prd', 'prod'].includes(lEnv)) {
        console.warn(`Unknown environment "${env}" passed to wlc360i URL helper. Defaulting to DEV settings.`);
    }
    const envEnum = mapStringEnvToEnvironments(lEnv);
    const envLetter = getUrlEnvLetterFromEnv(envEnum);
    // Only PROD uses the detected region; DEV, QA, STAGE always use US region
    const regionShortName = envEnum === Environments.PROD
        ? getRegionShortName()
        : US_REGION_SHORT_NAME;
    return `https://${subDomain}.wlc360i-${envLetter}-${regionShortName}.autodesk.com`;
};
/**
 * wlc360i host only (no /dev|/stg|/prd). Used for sensorData CDN reads where
 * paths are /{tenantId}/…; environment is encoded in the hostname tier letter.
 */
export const generateWlc360iHostUrl = (subDomain, env) => {
    return buildWlc360iOrigin(subDomain, env);
};
/**
 * Helper method to generate URL in wlc360i format
 * Example: https://saas-favorites.wlc360i-c-uw2.autodesk.com/dev
 * Note: DEV, QA, and STAGE always use US region (uw2). Only PROD uses the detected region.
 */
export const generateWlc360iUrl = (subDomain, env) => {
    const lEnv = env.toLowerCase();
    return appendPathToUrl(buildWlc360iOrigin(subDomain, lEnv), lEnv);
};
